(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kaeviq-checkout-trust"] && !Shopify.designMode) return;
  try {
    
(function () {
function kqBindDiscountForms() {
  document.querySelectorAll('[data-kq-code-form]').forEach(function(form){
    if(form.dataset.bound)return;
    form.dataset.bound='true';
    form.addEventListener('submit',async function(event){
      event.preventDefault();
      var input=form.querySelector('input'),button=form.querySelector('button'),message=form.querySelector('[role="status"]');
      var code=input.value.trim();if(!code)return;
      button.disabled=true;message.textContent='Kod kontrol ediliyor…';
      try{
        var base=window.Shopify&&window.Shopify.routes?window.Shopify.routes.root:'/';
        var currentResponse=await fetch(base+'cart.js',{credentials:'same-origin',cache:'no-store'});
        if(!currentResponse.ok)throw new Error('Sepet okunamadı. Lütfen tekrar deneyin.');
        var current=await currentResponse.json();
        var codes=(current.discount_codes||[]).filter(function(entry){return entry.applicable;}).map(function(entry){return entry.code;});
        if(!codes.some(function(value){return value.toLowerCase()===code.toLowerCase();}))codes.push(code);
        var response=await fetch(base+'cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({discount:codes.join(',')})});
        var updated=await response.json();
        if(!response.ok)throw new Error(updated.description||'Kod uygulanamadı.');
        var accepted=(updated.discount_codes||[]).some(function(entry){return entry.applicable&&entry.code.toLowerCase()===code.toLowerCase();});
        if(!accepted){message.textContent='Bu kod geçersiz veya mevcut sepet ve kampanyalarla kullanılamıyor.';return;}
        message.textContent='İndirim uygulandı. Sepet güncelleniyor…';
        window.location.reload();
      }catch(error){message.textContent=error.message||'Bağlantı hatası. Lütfen tekrar deneyin.';}
      finally{button.disabled=false;}
    });
  });
}
kqBindDiscountForms();
document.addEventListener('shopify:section:load',kqBindDiscountForms);
window.kqSetGroupQty = kqSetGroupQty;
window.kqChangeQty = kqChangeQty;
window.kqRemoveGroup = kqRemoveGroup;
window.kqPayment = kqPayment;
function kqSetGroupQty(input) {
  var row=input.closest('.kq-product'),form=input.form;
  var target=Math.max(0,Math.floor(Number(input.value)||0)),remaining=target;
  var lines=Array.from(form.querySelectorAll('[data-kq-line]')).filter(function(line){return line.dataset.group===row.dataset.group;});
  lines.forEach(function(line,index){
    var quantity=index===lines.length-1?remaining:Math.min(remaining,Number(line.value)||0);
    line.value=quantity;remaining-=quantity;
  });
  input.value=target;
  form.submit();
}
function kqChangeQty(button,amount) {
  var input=button.closest('.kq-qty').querySelector('input');
  input.value=Math.max(0,(parseInt(input.value,10)||0)+amount);
  kqSetGroupQty(input);
}
function kqRemoveGroup(link) {
  var input=link.closest('.kq-product').querySelector('.kq-qty input');
  input.value=0;kqSetGroupQty(input);return false;
}
function kqPayment(type) {
  document.getElementById('kq-method-card').classList.toggle('active',type==='card');
  document.getElementById('kq-method-transfer').classList.toggle('active',type==='transfer');
  document.getElementById('kq-transfer-message').classList.toggle('show',type==='transfer');
}
(function(){
  var cartForm=document.getElementById('kq-cart-form');
  if(!cartForm)return;
  var root=cartForm.closest('.kq-cart-page');
  root.querySelectorAll('.kq-rec-select').forEach(function(select){
    select.addEventListener('change',function(){select.closest('.kq-rec').querySelector('.kq-rec-price').textContent=select.options[select.selectedIndex].dataset.price;});
  });
  root.querySelectorAll('.kq-rec-form').forEach(function(form){
    form.addEventListener('submit',async function(event){
      event.preventDefault();
      var button=form.querySelector('button'),error=form.querySelector('.kq-error');
      button.disabled=true;error.textContent='';
      try{
        var response=await fetch(form.action+'.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});
        var result=await response.json();
        if(!response.ok)throw new Error(result.description||'Ürün eklenemedi. Lütfen tekrar deneyin.');
        window.location.href=root.dataset.cartUrl||'/cart';
      }catch(err){error.textContent=err.message;button.disabled=false;}
    });
  });
})();
// Read current Shopify cart reductions as well as older line-price fields.
function kqReadDiscounts(cart) {
  var entries=new Map(),pending=[];
  var add=function(title,amount){if(amount>0)entries.set(title,(entries.get(title)||0)+amount);};
  var number=function(value,fallback){return typeof value==='number'&&Number.isFinite(value)?value:fallback;};
  var groups=[];
  (cart.items||[]).forEach(function(item){
    var qty=number(item.quantity,0),original=number(item.original_line_price,number(item.original_price,item.price||0)*qty);
    var finals=[item.final_line_price,item.line_price,typeof item.discounted_price==='number'?item.discounted_price*qty:null].filter(function(x){return typeof x==='number'&&Number.isFinite(x);});
    var final=finals.length?Math.min.apply(null,finals):original,allocated=0;
    var allocations=item.line_level_discount_allocations||[];
    allocations.forEach(function(a){var amount=number(a.amount,0);allocated+=amount;add((a.discount_application||{}).title||'Ürün indirimi',amount);});
    var reduction=Math.max(0,original-final-allocated);
    if(reduction>0){
      var legacy=(item.discounts||[]).filter(function(d){return d.title;});
      var name=legacy.length===1?legacy[0].title:((/tasarım kılıf|tasarım telefon kılıfı|gloslu|glosslu|rujlu/i.test(item.product_title||item.title||''))?'Baskılı / gloslu kılıf indirimi':'Premium ürün indirimi');
      pending.push({title:name,amount:reduction});
    }
    groups.push({item:item,original:original,final:final});
  });
  (cart.cart_level_discount_applications||[]).forEach(function(d){add(d.title||'Sepet indirimi',number(d.total_allocated_amount,0));});
  var original=number(cart.original_total_price,groups.reduce(function(sum,g){return sum+g.original;},0));
  var total=number(cart.total_price,original);
  var budget=Math.max(0,original-total),rows=[];
  entries.forEach(function(amount,title){amount=Math.min(amount,budget);if(amount>0){rows.push({title:title,amount:amount});budget-=amount;}});
  pending.forEach(function(d){var amount=Math.min(d.amount,budget);if(amount>0){var existing=rows.find(function(r){return r.title===d.title;});if(existing)existing.amount+=amount;else rows.push({title:d.title,amount:amount});budget-=amount;}});
  if(budget>0)rows.push({title:'Diğer sepet indirimleri',amount:budget});
  return {original:original,total:total,rows:rows,groups:groups};
}
(function(){
  var form=document.getElementById('kq-cart-form');if(!form)return;
  var root=form.closest('.kq-cart-page'),busy=false;
  var money=function(cents,currency){return new Intl.NumberFormat('tr-TR',{minimumFractionDigits:2,maximumFractionDigits:2}).format(cents/100)+' '+(currency==='TRY'?'TL':currency);};
  var properties=function(value){var result=value&&typeof value==='object'?value:{};return JSON.stringify(Object.keys(result).sort().map(function(key){return [key,result[key]];}));};
  async function refresh(){
    if(busy||!root.isConnected)return;busy=true;
    try{
      var base=window.Shopify&&window.Shopify.routes?window.Shopify.routes.root:'/';
      var response=await fetch(base+'cart.js',{credentials:'same-origin',cache:'no-store',headers:{'Accept':'application/json'}});
      if(!response.ok)return;
      var cart=await response.json(),data=kqReadDiscounts(cart);
      // Avoid applying totals to product cards from a different cart state.
      var expected=Array.from(form.querySelectorAll('[data-kq-line]')).reduce(function(sum,input){return sum+Number(input.value);},0);
      if(expected!==cart.item_count)return;
      var currency=cart.currency||'TRY',summary=root.querySelector('.kq-summary');
      var shipping=summary.querySelector('[data-kq-shipping]').closest('.kq-summary-row');
      summary.querySelectorAll('.kq-discount-row').forEach(function(row){row.remove();});
      data.rows.forEach(function(d){var row=document.createElement('div'),label=document.createElement('span'),amount=document.createElement('strong');row.className='kq-summary-row kq-discount-row';label.textContent=d.title;amount.textContent='−'+money(d.amount,currency);row.append(label,amount);shipping.before(row);});
      summary.querySelector('[data-kq-subtotal]').textContent=money(data.original,currency);
      summary.querySelector('.kq-total-price').textContent=money(data.total,currency);
      summary.querySelector('[data-kq-summary-count]').textContent='Ürünler ('+cart.item_count+' adet)';
      root.querySelectorAll('.kq-product[data-variant]').forEach(function(row){
        var props;try{props=JSON.parse(row.dataset.properties);}catch(e){return;}
        var matches=data.groups.filter(function(g){var item=g.item;return String(item.variant_id||item.id)===row.dataset.variant&&properties(item.properties)===properties(props)&&String(item.selling_plan_allocation&&item.selling_plan_allocation.selling_plan?item.selling_plan_allocation.selling_plan.id:'')===row.dataset.plan&&String(item.original_price===undefined?item.price:item.original_price)===row.dataset.originalPrice;});
        if(!matches.length)return;
        var original=matches.reduce(function(sum,g){return sum+g.original;},0),final=matches.reduce(function(sum,g){return sum+g.final;},0);
        var price=row.querySelector('.kq-line-price'),unit=price.querySelector('.kq-unit-price');
        price.replaceChildren();if(final<original){var old=document.createElement('del');old.className='kq-old-price';old.textContent=money(original,currency);price.append(old);}
        price.append(document.createTextNode(money(final,currency)));if(unit)price.append(unit);
      });
    }catch(error){/* Keep the server-rendered prices if refresh fails. */}finally{busy=false;}
  }
  refresh();[700,1800,3500].forEach(function(delay){setTimeout(refresh,delay);});
  document.addEventListener('cart:updated',refresh);document.addEventListener('cart:refresh',refresh);
})();
})();

(function () {
  function kqBusinessDate(base, offset) {
    var date = new Date(base.getTime());
    var remaining = offset;
    while (remaining > 0) {
      date.setUTCDate(date.getUTCDate() + 1);
      if (date.getUTCDay() !== 0 && date.getUTCDay() !== 6) remaining--;
    }
    return date;
  }
  function kqUpdateDeliveryDates() {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Istanbul', year: 'numeric', month: 'numeric', day: 'numeric'
    }).formatToParts(new Date());
    var values = {};
    parts.forEach(function (part) { values[part.type] = part.value; });
    var today = new Date(Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day)));
    var formatter = new Intl.DateTimeFormat('tr-TR', {timeZone: 'UTC', day: 'numeric', month: 'long'});
    document.querySelectorAll('[data-kq-business-offset]').forEach(function (node) {
      var date = kqBusinessDate(today, Number(node.dataset.kqBusinessOffset) || 0);
      node.textContent = formatter.format(date);
      node.dateTime = date.toISOString().slice(0, 10);
    });
  }
  kqUpdateDeliveryDates();
  document.addEventListener('shopify:section:load', kqUpdateDeliveryDates);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) kqUpdateDeliveryDates(); });
  setInterval(kqUpdateDeliveryDates, 60000);
})();

  } catch(e) { console.error(e); }
})();
})();
